import { createAction } from 'redux-actions';
import { isNullOrUndefined } from 'utils/object-utils';
import {
  postMaintenanceBannerRequest,
  getAllMaintenancePageBannerData,
} from '../../api/admin-module-api';
import {
  getContainerListWhereUserIsCountryManager,
  getContainerListWhereUserIsCountryManagerWithContainerCodes,
} from 'api/project-list-api';
import { ADMIN_MODULE_TABS } from 'constants/feature/admin-module-constants';
import AdminModuleMaintenanceList from 'models/data/admin-module-maintenance-page-list-model';

export const setCurrentAdminModuleTab = createAction(
  'SET_CURRENT_ADMIN_MODULE_TAB',
);

export const setMaintenacePageLoading = createAction(
  'SET_MAINTENANCE_PAGE_LOADING_ACTION',
);

export const setMaintenacePageLoaded = createAction(
  'SET_MAINTENANCE_PAGE_LOADED_ACTION',
);

export const setMaintenancePageError = createAction(
  'SET_MAINTENANCE_PAGE_ERROR_ACTION',
);

export const countryManagercontainerListLoading = createAction(
  'COUNTRY_MANAGER_CONTAINER_LIST_LOADING_ACTION',
);

export const countryManagercontainerListLoaded = createAction(
  'COUNTRY_MANAGER_CONTAINER_LIST_LOADED_ACTION',
);

export const countryManagercontainerListError = createAction(
  'COUNTRY_MANAGER_CONTAINER_LIST_ERROR_ACTION',
);

export const monitoringListLoading = createAction(
  'MONITORING_COUNTRY_LIST_LOADING_ACTION',
);

export const monitoringListLoaded = createAction(
  'MONITORING_COUNTRY_LIST_LOADED_ACTION',
);

export const monitoringListError = createAction(
  'MONITORING_COUNTRY_LIST_ERROR_ACTION',
);

export const clearMonitoringListLoaded = createAction(
  'CLEAR_MONITORING_COUNTRY_LIST_DATA_ACTION',
);

export const setCountryOption = createAction(
  'SET_COUNTRY_LIST_SELECTED_OPTIONS',
);
export const clearAdminPageDataAction = createAction(
  'CLEAR_ADMIN_PAGE_DATA_ACTION',
);

export const requestCurrentAdminModuleTab =
  ({ tab, selectedGeo }) =>
  async (dispatch, getState) => {
    if (!isNullOrUndefined(tab)) {
      await dispatch(setCurrentAdminModuleTab(tab));
      if (tab === ADMIN_MODULE_TABS.MAINTENANCEBANNER) {
        await dispatch(getAllMaintenanceBannerData(selectedGeo));
      }
    }
  };

export const getAllMaintenanceBannerData =
  (selectedGeo, withLoading = true) =>
  async (dispatch, getState) => {
    withLoading && dispatch(setMaintenacePageLoading());
    try {
      let bannerList = await getAllMaintenancePageBannerData(selectedGeo);
      dispatch(setMaintenacePageLoaded(bannerList));
    } catch (e) {
      //Loaded with error;
      dispatch(setMaintenancePageError(e));
    }
  };
export const maintenanceBannerSaveAction =
  (isActive, id, text, startDate, endDate, selectedGeo) =>
  async (dispatch, getState) => {
    dispatch(setMaintenacePageLoading());
    await postMaintenanceBannerRequest(
      isActive,
      id,
      text,
      startDate,
      endDate,
      selectedGeo,
    );
    await dispatch(getAllMaintenanceBannerData(selectedGeo));
  };

export const postAdminMaintenanceBannerAction = async (
  isActive,
  id,
  text,
  startDate,
  endDate,
) => {
  try {
    const response = await postMaintenanceBannerRequest(
      isActive,
      id,
      text,
      startDate,
      endDate,
    );
    if (response && response.data && response.data.result) {
      const bannerData = new AdminModuleMaintenanceList().setLoaded([
        response.data.result,
      ]);
      return (
        (bannerData &&
          bannerData.data &&
          bannerData.data.maintenanceBannerDataList.length &&
          bannerData.data.maintenanceBannerDataList[0]) ||
        {}
      );
    }
    return {};
  } catch (e) {
    console.error(e);
  }
};

//THis country list we are using on admin module's Manage Users page
export const getContainerListWhereUserIsCountryManagerAction =
  () => async (dispatch, getState) => {
    dispatch(countryManagercontainerListLoading());
    try {
      const data = await getContainerListWhereUserIsCountryManager();
      await dispatch(countryManagercontainerListLoaded(data));
    } catch (error) {
      dispatch(countryManagercontainerListError(error));
    }
  };

export const getContainerMonitoringDropDownList =
  (countryCodes) => async (dispatch, getState) => {
    dispatch(monitoringListLoading());
    try {
      const monitoringList =
        await getContainerListWhereUserIsCountryManagerWithContainerCodes(
          countryCodes,
        );
      await dispatch(monitoringListLoaded(monitoringList));
    } catch (error) {
      dispatch(monitoringListError(error));
    }
  };

export const setMonitoringDropDownSelectedOptions =
  (option) => async (dispatch, getState) => {
    dispatch(setCountryOption(option));
  };
